enum LoginAnalyticsPageView {
  ForgotPassword = "Forgot Password",
  Login = "Login",
  MFA = "Multi-Factor Authentication",
}

enum LoginAnalyticsEvent {
  BackToLoginPressed = "Back to login pressed",
  BiometricsDisabled = "Biometrics disabled",
  BiometricsSetUp = "Biometrics set up",
  ClearCache = "Clear cache pressed",
  ClearCacheConfirmed = "Clear cache confirmed pressed",
  ContactHelpCenterPressed = "Contact support pressed",
  FailedLogin = "Failed login",
  ForgotPasswordPressed = "Forgot password pressed",
  Logout = "Logout",
  RememberMeChecked = "Remember me check",
  RememberMeUnchecked = "Remember me uncheck",
  SendResetEmailPressed = "Send reset email pressed",
  SignInPressed = "Sign in pressed",
  SuccessfulLogin = "Successful login",
}

enum FailedLoginReason {
  Auth0Timeout = "Auth0 timeout",
  Credentials = "Invalid credentials",
  NetworkError = "Network unavailable",
  Other = "Other login error encountered",
  TooManyAttempts = "Too many attempts",
  Unauthorized = "Unauthorized",
}

export { FailedLoginReason, LoginAnalyticsEvent, LoginAnalyticsPageView };
